/* eslint-disable no-unused-vars */
import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import './offer_buttons_cell.scss';
import TaskOfferButtons from '../../../components/task_offer_buttons/task_offer_buttons';

const OfferButtonsCell = ({ value }) => {
  const assignedCompany = _.get(value, 'assigned_company');
  const taskId = _.get(value, 'id');

  return (
    <TaskOfferButtons
      assignedCompany={assignedCompany}
      offerTaskAccept={value.offerTaskAccept}
      offerTaskDecline={value.offerTaskDecline}
      taskId={taskId}
    />
  );
};

OfferButtonsCell.propTypes = {
  value: PropTypes.shape({
    assigned_company: PropTypes.shape({}),
    id: PropTypes.number,
    offerTaskAccept: PropTypes.func,
    offerTaskDecline: PropTypes.func,
  }),
};

OfferButtonsCell.defaultProps = {
  value: {
    offerTaskAccept: () => {},
    offerTaskDecline: () => {},
  },
};

export default OfferButtonsCell;
